import { Edit as EditIcon, DownloadRounded as ImportIcon, PlayArrow as PlayIcon } from '@mui/icons-material';
import { Dialog, IconButton } from '@mui/material';
import apiEndpoints from 'constants/endpoints';
import { DataGridListPage } from 'pages/Common';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { pageKeys } from 'store/reducers/dataGrid.reducer';
import { formatBytes } from 'utils/file';
import { formatSeconds } from 'utils/time';


export const AntMediaImportVideos = () => {
  const history = useHistory();
  const [previewUrl, setPreviewUrl] = useState('');

  const columns = useMemo(() => {
    return [
      {
        field: 'startTime',
        headerName: 'Recorded At',
        width: 200,
        cellRenderer: ({ data }) => new Date(data.startTime).toLocaleString()
      },
      {
        field: 'creationDate',
        headerName: 'Ended At',
        width: 200,
        cellRenderer: ({ data }) => new Date(data.creationDate).toLocaleString()
      },
      {
        field: 'duration',
        headerName: 'Duration',
        width: 100,
        cellRenderer: ({ data }) => formatSeconds(data.duration/1000),
      },
      {
        field: 'fileSize',
        headerName: 'File Size',
        width: 120,
        cellRenderer: ({ data }) => formatBytes(data.fileSize),
      },
      {
        field: 'preview',
        headerName: 'Preview',
        width: 100,
        cellStyle: {textAlign: 'center'},
        headerClass: 'text-center',
        cellRenderer: ({ data }) => <IconButton color='secondary' size='small' onClick={() => setPreviewUrl(data.url)}><PlayIcon /></IconButton>,
      },
      {
        field: 'description',
        headerName: 'Description',
        flex: 1,
      },
      {
        field: 'actions',
        headerName: 'Actions',
        width: 100,
        cellStyle: {textAlign: 'center'},
        headerClass: 'text-center',
        cellRenderer: ({ data }) => (
          data.videoId ? 
          <IconButton size="small" color="primary" onClick={() => history.push(`/${apiEndpoints.videos}/${data.videoId}`)}><EditIcon /></IconButton> :
          <IconButton size="small" color="primary" title="Import" onClick={() => history.push(`/${apiEndpoints.videos}/new`, {recording: data})}><ImportIcon /></IconButton>
        ),
      },
    ];
  }, [history]);

  const filters = [
    {
      field: 'streamId',
      label: 'Stream ID',
      type: 'search',
      value: null
    },
  ];

  return (
    <>
      <DataGridListPage
        columns={columns}
        filters={filters}
        apiEndpoint="antmedia/recordings"
        hasPagination={false}
        heading="Import Recordings from Wasabi"
        pageKey={pageKeys.antMediaImportVideos}
        requiredQueryParams={['streamId']}
      />
      <Dialog
        open={!!previewUrl}
        onClose={() => setPreviewUrl('')}
      >
          <video src={previewUrl} controls width="100%" />
      </Dialog>
    </>
)
}

